<template>
  <v-container>
    <parent-dialog-popup
      :dialog="value"
      @dialogItem="moveCheckpoint($event)"
      @item-selected="handleItemSelected"
      @add-item-selected="addHandleItemSelected"
      @back="emit('input', false)"
      @search="emit('search', $event)"
      @load-more="emit('load-more')"
      :label="OrgObjectType"
      :objectType="extractedWords.join(' ')"
      :parentName="parentName"
      :items="items"
      :existingNamesList="existingNamesList"
      :hasMoreData="hasMoreData"
      :isLoadingMore="isLoadingMore"
      buttonLabel="Move"
      modalType="Move"
      :retainFocus="false"
      type="move_checkpoint"
      :maxWidth="'612'"
      :autoOpen="autoOpen"
      :autoFocus="autoFocus"
    />
  </v-container>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import ParentDialogPopup from '@components/ParentModal/ParentDialogPopup.vue';

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  OrgObjectType: {
    type: String,
    default: 'Responsibility to Role',
  },
  parentName: {
    type: String,
    default: 'Team Leader',
  },
  items: {
    type: Array,
    default: () => [],
  },
  existingNamesList: {
    type: Array,
    default: () => [],
  },
  buttonLabel: {
    type: String
  },
  autoOpen: {
    type: Boolean,
    default: false,
  },
  autoFocus: {
    type: Boolean,
    default: false,
  },
  hasMoreData: {
    type: Boolean,
    default: false,
  },
  isLoadingMore: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['input', 'onSave', 'item-selected', 'add-item-selected', 'load-more', 'search']);

const extractedWords = ref([]);

const extractedOrgObjectType = computed(() => {
  if (props.OrgObjectType) {
    const index = props.OrgObjectType.indexOf(' to ');
    if (index !== -1) {
      return props.OrgObjectType.substring(0, index);
    }
  }
  return '';
});

watch(() => props.OrgObjectType, (newValue) => {
  extractedWords.value = extractedOrgObjectType.value.split(' ');
});

onMounted(() => {
  if (props.OrgObjectType) {
    extractedWords.value = extractedOrgObjectType.value.split(' ');
  }
});

const moveCheckpoint = (role) => {
  emit("onSave", role);
};

const handleItemSelected = (data) => {
  emit("item-selected", data);
};

const addHandleItemSelected = (data) => {
  emit("add-item-selected", data);
};
</script>
<style>
  .custom-list {
    margin-top: -10px;
    width: 564px;
  }
  .v-text-field__slot {
    height: auto;
  }
</style>